import {environment} from "$lib/env";

const apiUrl = environment.apiUrl

export const getProviders = async () => {
  const response = await fetch(`${apiUrl}/game-providers`);
  return response.json();
}
